import React from 'react';
import { motion } from 'framer-motion';
interface FractionPizzaProps {
  numerator: number;
  denominator: number;
  label?: string;
  type?: 'pizza' | 'chocolate' | 'cake';
  showEaten?: boolean;
}
export function FractionPizza({
  numerator,
  denominator,
  label,
  type = 'pizza',
  showEaten = false
}: FractionPizzaProps) {
  const percentage = numerator / denominator * 100;
  // Determine how many pieces to show as filled
  const filledPieces = showEaten ? denominator - numerator : numerator;
  const getEmoji = () => {
    switch (type) {
      case 'pizza':
        return '🍕';
      case 'chocolate':
        return '🍫';
      case 'cake':
        return '🍰';
      default:
        return '🍕';
    }
  };
  const getTitle = () => {
    switch (type) {
      case 'pizza':
        return 'Pizza';
      case 'chocolate':
        return 'Chocoladereep';
      case 'cake':
        return 'Taart';
      default:
        return 'Pizza';
    }
  };
  // Generate pieces based on denominator
  const pieces = Array.from({
    length: denominator
  }, (_, i) => i);
  // Determine grid layout based on denominator
  const getGridCols = () => {
    if (denominator <= 4) return 'grid-cols-2';
    if (denominator <= 6) return 'grid-cols-3';
    if (denominator <= 9) return 'grid-cols-3';
    return 'grid-cols-4';
  };
  return <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200" data-id="element-1077">
      <div className="text-center mb-4" data-id="element-1078">
        <h4 className="font-bold text-amber-900 mb-2 text-lg flex items-center justify-center gap-2" data-id="element-1079">
          <span className="text-2xl" data-id="element-1080">{getEmoji()}</span>
          {getTitle()}
        </h4>
        {label && <p className="text-slate-700 font-medium" data-id="element-1081">{label}</p>}
      </div>

      {/* Visual Representation */}
      <div className={`grid ${getGridCols()} gap-3 mb-4 max-w-md mx-auto`} data-id="element-1082">
        {pieces.map(i => {
        const isFilled = i < filledPieces;
        return <motion.div key={i} initial={{
          scale: 0,
          rotate: -180
        }} animate={{
          scale: 1,
          rotate: 0
        }} transition={{
          delay: i * 0.05,
          type: 'spring',
          stiffness: 200
        }} className={`aspect-square rounded-lg border-4 flex items-center justify-center text-4xl ${isFilled ? 'bg-gradient-to-br from-amber-400 to-orange-500 border-amber-600 shadow-lg' : 'bg-slate-100 border-slate-300'}`} data-id="element-1083">
              {isFilled && <motion.span initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: i * 0.05 + 0.1
          }} data-id="element-1084">
                  {getEmoji()}
                </motion.span>}
            </motion.div>;
      })}
      </div>

      {/* Explanation */}
      <div className="bg-white rounded-lg p-4 border-2 border-amber-200" data-id="element-1085">
        <div className="text-center" data-id="element-1086">
          <p className="text-2xl font-bold text-amber-900 mb-2" data-id="element-1087">
            {numerator}/{denominator}
          </p>
          <p className="text-slate-700" data-id="element-1088">
            {showEaten ? <>
                <span className="font-bold text-amber-700" data-id="element-1089">{numerator}</span>{' '}
                van de{' '}
                <span className="font-bold text-slate-900" data-id="element-1090">{denominator}</span>{' '}
                stukken zijn{' '}
                <span className="font-bold text-slate-600" data-id="element-1091">opgegeten</span>
              </> : <>
                <span className="font-bold text-amber-700" data-id="element-1092">{numerator}</span>{' '}
                van de{' '}
                <span className="font-bold text-slate-900" data-id="element-1093">{denominator}</span>{' '}
                stukken zijn{' '}
                <span className="font-bold text-amber-700" data-id="element-1094">over</span>
              </>}
          </p>
        </div>
      </div>

      {/* Tip */}
      <div className="mt-4 bg-emerald-50 rounded-lg p-3 border border-emerald-200" data-id="element-1095">
        <p className="text-sm text-emerald-900 text-center" data-id="element-1096">
          💡 <strong data-id="element-1097">Onthoud:</strong> De onderkant (noemer) zegt hoeveel
          stukken er in totaal zijn. De bovenkant (teller) zegt hoeveel je hebt.
        </p>
      </div>
    </div>;
}